import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 仕入れ先名を取得するユースケース
 * @param supplier - 仕入れ先情報
 */
export class GetSupplierNameUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }
  /**
   * 仕入れ先名を取得する
   * @param supplierNumber - 仕入れ先番号
   */
  async execute(supplierNumber: string): Promise<INetworkResult<string | undefined, IError>> {
    try {
      const result = await this.repository.getSupplierName(supplierNumber);
      return result;
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: {
            message: '想定外のエラーが発生しました',
            statusCode: 0,
            code: '',
          },
        },
      };
    }
  }
}
